'use strict';
var actionTypes = require('./actionTypes');
const client = require('../../sdk/client');

if (typeof window !== 'undefined') {
    var $ = window.$;
}

function goToPage(pageNumber, filters) {
    return function (dispatch, getState) {
        const state = getState().searchReducer;
        $("body").css("cursor", "wait");

        const user = getState().userReducer;
        const categoryIds = [];

        const customOptions = {
            strKeyword: state.keywords,
            arrCategories: state.customValues? state.customValues.arrCategories : null,
            arrCustomFieldQueries: state.customValues? state.customValues.arrCFQueries : null,
            strSort: state.sort,
            intPageNumber: pageNumber,
            intPageSize: 20,
            numMaxPrice: state.maximumPrice,
            numMinPrice: state.minimumPrice
        };

        client.CustomSearch.CustomSearch(customOptions).then((response) => {
                $("body").css("cursor", "default");
                return dispatch({
                type: actionTypes.GO_TO_PAGE,
                items: response,
                pageNumber: pageNumber,
                pageSize: 20
            });
        })
    };
}

function sortResult(sort) {
    return function (dispatch, getState) {
        const state = getState().searchReducer;

        const user = getState().userReducer;

        const customOptions = {
            strKeyword: state.keywords,
            arrCustomFieldQueries: state.customValues ? state.customValues.arrCFQueries : null,
            arrCategories: state.customValues ? state.customValues.arrCategories :null,
            strSort: sort,
            intPageNumber: 1,
            intPageSize: 20,
            numMinPrice: state.minimumPrice,
            numMaxPrice: state.maximumPrice
        };

        client.CustomSearch.CustomSearch(customOptions).then((response) => {
                return dispatch({
                    type: actionTypes.SORT_SEARCH_RESULT,
                    items: response,
                    sort: sort
            });
        })
    };
}

function changeResultDisplay(resultDisplayBehavior) {
    return {
        type: actionTypes.SET_SEARCH_RESULT_DISPLAY,
        resultDisplayBehavior: resultDisplayBehavior
    };
}

function searchByCategory(categories) {
    let categoryIds = [];

    function getCustomFields(categoryIds, callback) {
        $.ajax({
            url: '/search/items/custom-fields',
            type: 'GET',
            data: {
                categoryIds: categoryIds
            },
            success: function (result) {
                callback(result);
            },

            error: function (jqXHR, textStatus, errorThrown) {
                console.log(textStatus, errorThrown);
            }
        });
    }

    function getCategoryHierarchy(category, hierarchy, hierarchyCount) {
        if (hierarchy) {
            if (hierarchy.indexOf(category.ID) >= 0 || hierarchyCount > hierarchy.length) {
                if (category.ChildCategories) {
                    hierarchyCount = hierarchyCount + 1;
                    category.ChildCategories.forEach(function (c) {
                        getCategoryHierarchy(c, hierarchy, hierarchyCount);
                    });
                }

                categoryIds.push(category.ID);
            }
        } else {
            if (category.ChildCategories) {
                category.ChildCategories.forEach(function (c) {
                    getCategoryHierarchy(c);
                });
            }

            categoryIds.push(category.ID);
        }
    }

    return function (dispatch, getState) {
        const state = getState().categoryReducer;

        Array.from(categories).map(function (category, index) {
            if (category.Hierarchy) {
                getCategoryHierarchy(state.categories.find(c => c.ID == category.ParentId), category.Hierarchy, 1);
            } else {
                getCategoryHierarchy(state.categories.find(c => c.ID == category.ID));
            }
        });

        $.ajax({
            url: '/search/items/ajax',
            type: 'GET',
            data: {
                pageSize: getState().searchReducer.pageSize,
                pageNumber: 1,
                tags: '',
                withChildItems: getState().searchReducer.withChildItems,
                sort: process.env.PRICING_TYPE != 'service_level' ? 'item_desc' : 'nearest',
                //keywords: state.keywords,
                //minPrice: state.minimumPrice,
                //maxPrice: state.maximumPrice,
                categories: categoryIds,
                customValues: null
            },
            success: function (promiseItemsResult) {
                getCustomFields(categoryIds, function (result) {
                    const items = promiseItemsResult;
                    return dispatch({
                        type: actionTypes.SEARCH_BY_CATEGORY,
                        items: items,
                        selectedCategories: categories,
                        customFilters: result,
                    });
                });
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(textStatus, errorThrown);
            }
        });
    };
}

function searchByFilters(filters) {
    return function (dispatch, getState) {
        const state = getState().searchReducer;
        $("body").css("cursor", "wait");

        const customOptions = {
            strKeyword: state.keywords,
            arrCategories: filters.arrCategories,
            arrCustomFieldQueries: filters.arrCustomFieldQueries,
            strSort: state.sort,
            intPageNumber: 1,
            intPageSize: 20,
            numMaxPrice: filters.maximumPrice,
            numMinPrice: filters.minimumPrice
        };

        client.CustomSearch.CustomSearch(customOptions).then((response) => {
                $("body").css("cursor", "default");
                return dispatch({
                type: actionTypes.SEARCH_BY_FILTERS,
                items: response,
                minimumPrice: filters.minimumPrice,
                maximumPrice: filters.maximumPrice,
                customValues: filters.customValues,
                reviewAndRating: state.reviewAndRating,
                pageNumber: 1,
                pageSize: 20,
                customFilters: filters
            });;
        })
    };
}

function searchGooglePlaces(keyword, callback) {
    return function (dispatch, getState) {
        $.ajax({
            url: '/search/google-places',
            type: 'GET',
            data: {
                keyword: keyword
            },
            success: function (result) {
                callback(result);

                return dispatch({
                    type: ''
                });
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(textStatus, errorThrown);
            }
        });
    };
}

function searchSuggestedItems(lat, lng, callback) {
    return function (dispatch, getState) {
        const state = getState().searchReducer;

        $.ajax({
            url: '/search/suggested-items',
            type: 'GET',
            data: {
                userLatitude: lat,
                userLongitude: lng
            },
            success: function (result) {
                callback(result);

                return dispatch({
                    type: ''
                });
            },

            error: function (jqXHR, textStatus, errorThrown) {
                console.log(textStatus, errorThrown);
            }
        });
    };
}

module.exports = {
    sortResult,
    changeResultDisplay,
    goToPage,
    searchByCategory,
    searchByFilters,
    searchGooglePlaces,
    searchSuggestedItems
}